import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getUserRoles } from '../store';

export function useIsUserDeniedByRol(roles = []) {
  const userRoles = useSelector(getUserRoles);
  const rolesIndex = useMemo(() => (
    roles.reduce((index, role) => ({
      ...index,
      [role]: true
    }), {})
  ), [roles]);

  return useMemo(() => (
    roles.length && !userRoles.some((userRole) => rolesIndex[userRole])
  ), [roles.length, rolesIndex, userRoles]);
}

export default useIsUserDeniedByRol;
